import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ExternalLink, Briefcase } from 'lucide-react';

const PortfolioPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">Portfolio</h1>
        <p className="text-xl text-gray-600 mb-12">
          A collection of projects and capabilities showcasing our expertise in building modern web applications.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Turnkey Business Platform */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-2xl font-bold text-gray-900">Turnkey Business Platform</h2>
                <Briefcase className="h-6 w-6 text-blue-600" />
              </div>
              <p className="text-gray-600 mb-6">
                A comprehensive digital platform that can be customized for any business, featuring CRM, content management, multilingual support, and more.
              </p>
              <div className="flex justify-between items-center">
                <div className="flex space-x-2">
                  <span className="px-3 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">React</span>
                  <span className="px-3 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">TypeScript</span>
                  <span className="px-3 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">Supabase</span>
                </div>
                <Link 
                  to="/portfolio/platform-spec"
                  className="inline-flex items-center text-blue-600 hover:text-blue-800"
                >
                  <FileText className="h-4 w-4 mr-1" />
                  View Specification
                </Link>
              </div>
            </div>
          </div>

          {/* Placeholder for future projects */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden border-2 border-dashed border-gray-200 flex items-center justify-center p-8">
            <div className="text-center">
              <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <ExternalLink className="h-8 w-8 text-gray-400" />
              </div>
              <h3 className="text-xl font-semibold text-gray-400 mb-2">More Projects Coming Soon</h3>
              <p className="text-gray-500">Additional portfolio items will be added here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioPage;